import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-view-booking-company-room',
  templateUrl: './view-booking-company-room.component.html',
  styleUrls: ['./view-booking-company-room.component.scss']
})
export class ViewBookingCompanyRoomComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
